import { Router } from "../../../../routes";

export const goToResults = () => {
  Router.pushRoute("results", Router.router.query);
};
